import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export function MeteringSummaryCard({ energyData, currencySymbol }) {
    const { t } = useTranslation();

    return (
        <Card>
            <CardContent>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                            <Typography variant="h5">
                                {
                                    (energyData.consumption_kwh) ?
                                        (
                                            Object.values(energyData.consumption_kwh).reduce(
                                                (acc, val) => acc + (val.reduce((acc2, val2) => acc2 + val2, 0.0))
                                                , 0.0
                                            )
                                        )
                                            .toLocaleString(undefined, { maximumFractionDigits: 0 })
                                        : ""
                                } kWh
                            </Typography>
                            <Typography variant="subtitle2">
                                {t("Total Consumption")}
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>



                            <Typography variant="h5">{currencySymbol} {
                                (energyData.cost) ?
                                    (
                                        Object.values(energyData.cost).reduce(
                                            (acc, val) => acc + (val.reduce((acc2, val2) => acc2 + val2, 0.0))
                                            , 0.0
                                        )
                                    )
                                        .toLocaleString(undefined, { maximumFractionDigits: 0 })
                                    : ""
                            }</Typography>

                            <Typography variant="subtitle2">
                                {t("Total Cost")}
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>

                            <Typography variant="h5">{
                                (energyData.co2_kg) ?
                                    (
                                        Object.values(energyData.co2_kg).reduce(
                                            (acc, val) => acc + (val.reduce((acc2, val2) => acc2 + val2, 0.0))
                                            , 0.0
                                        )
                                    )
                                        .toLocaleString(undefined, { maximumFractionDigits: 0 })
                                    : ""
                            } kgCO2
                            </Typography>

                            <Typography variant="subtitle2">
                                {t("Total CO2")}
                            </Typography>
                        </Stack>
                    </Grid>
                </Grid>

            </CardContent>
        </Card>

    )
}